export const customerHasFeature = (customer, featureId) => {
  return customer?.enabledFeatures?.indexOf(featureId) !== -1
}
